import React, { useState } from 'react'
import FinePrint from 'components/Common/FinePrint'
import Modal from 'LuxKit/Modal/Modal'

interface Props {
  offer: App.Offer
  defaultShowModal?: boolean
}

export default function FinePrintModal({ offer }: Props) {
  // don't auto-open modal - user must click 'see fine print' button to see fine print
  const [showModal, setShowModal] = useState(false)

  return (
    <Modal
      size="L"
      isOpen={showModal}
      title="Fine print"
      onClose={() => setShowModal(false)}
    >
      <FinePrint finePrint={offer.finePrint} offer={offer} />
    </Modal>
  )
}
